import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import wirePropType from './prop-types';
import Ul from './common-styles';
import ViewCount from './view-count';
import EngagementCount from './engagement-count';

const Ulist = styled.ul`
  ${Ul};

  & > li {
    span {
      color: ${props => dt(props).theme.primaryColor};
    }

    .icon-lw {
      opacity: .5;
    }
  }
`;

export default function StatisticsGroup({ wire }) {
  return (
    <Ulist className="--statistics">
      <li data-tooltip title="Views">
        <ViewCount wire={wire} />
      </li>
      <li data-tooltip title="Engagements">
        <EngagementCount wire={wire} />
      </li>
    </Ulist>
  );
}

StatisticsGroup.propTypes = wirePropType;
